import { createBrowserClient } from '@supabase/ssr'
import { Database, Json } from './database.types'

// Use createBrowserClient for client-side instance
export const supabase = createBrowserClient<Database>(
  process.env.NEXT_PUBLIC_SUPABASE_URL!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
)

// Simple database types
export type Profile = {
  id: string
  email: string
  full_name: string | null
  company_name: string | null
  avatar_url?: string
  year_founded?: string | null
  employee_count?: string | null
  certifications?: Json | null
  contract_vehicles?: string | null
  
  // Personal fields
  job_title?: string | null
  years_of_experience?: number | null
  phone_number?: string | null
  linkedin_url?: string | null
  security_clearance?: string | null
  education?: string | null

  // Company fields
  company_website?: string | null
  company_size?: string | null
  company_duns?: string | null
  company_cage_code?: string | null
  company_naics_codes?: string[] | null
  company_address?: string | null
  company_city?: string | null
  company_state?: string | null
  company_zip?: string | null
  company_country?: string | null
  company_logo_url?: string | null
  business_type?: string[] | null
  capabilities_statement_url?: string | null
  past_performance?: Json | null
  strategic_markets?: string[] | null
  target_locations?: string[] | null
  business_summary?: string | null
  coaching_preferences?: Json | null
  onboarding_completed?: boolean | null
  created_at?: string
  updated_at?: string
}

export type Subscription = {
  id: string
  user_id: string
  status: 'active' | 'canceled' | 'past_due' | 'trialing'
  tier: string
  stripe_customer_id?: string | null
  stripe_subscription_id?: string | null
  current_period_start?: string | Date | null
  current_period_end?: string | Date | null
  // Trial fields
  trial_ends_at?: string | Date | null
  trial_ai_requests_used?: number
  // AI usage fields
  ai_tokens_used_this_period?: number
  ai_tokens_included?: number
  ai_tokens_purchased?: number
  billing_interval?: 'month' | 'year'
  spending_cap_cents?: number
  user_spending_cap_cents?: number | null
  created_at?: string | Date
  updated_at?: string | Date
} 